import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const reasons = ['Los suplementos genéricos de farmacia no consideran tu bio-individualidad única.', "El consejo de 'hacer más yoga' no apaga un sofoco volcánico en medio de una reunión importante.", 'Las dietas restrictivas solo estresan más a tus glándulas suprarrenales, empeorando la fatiga.', 'Ignorar los síntomas solo hace que la transición sea más larga y dolorosa.'];
export function WhyItDidntWork() {
  return <section className="w-full bg-ivory py-20 md:py-28" data-id="element-148">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown tracking-wide mb-4" data-id="element-151">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="w-24 h-[1px] bg-terracotta mx-auto" data-id="element-152"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-153">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-sm shadow-sm flex items-start gap-4 border border-taupe/30" data-id="element-154">
              <div className="mt-1 flex-shrink-0" data-id="element-155">
                <XIcon className="w-6 h-6 text-terracotta" data-id="element-156" />
              </div>
              <p className="text-text-brown-light leading-relaxed" data-id="element-157">{reason}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}